// src/main.js
import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "@/styles/style.css";
import Particles from "@tsparticles/vue3";
import { loadSlim } from "@tsparticles/slim";
if (!customElements.get("spline-viewer")) {
  import("@splinetool/viewer");
}

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(ElementPlus);

app.use(Particles, {
  init: async (engine) => {
    await loadSlim(engine);
  },
});

router.isReady().then(() => {
  app.mount("#app");
});
